import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import vuetify from "./plugins/vuetify";
import User from "./User";

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URI;

const AUTHENTICATED_ROUTES = ["/arma/", "/users/userPromotionMessages", "/users/discord", "/community/"];

Vue.axios.interceptors.request.use(async (config) => {
  let user = localStorage.getItem("user");

  if (
    config.url !== undefined &&
    AUTHENTICATED_ROUTES.some((route) => config.url!.includes(route)) &&
    config.method !== "OPTIONS"
  ) {
    // Skip token refresh check for the refresh endpoint itself to avoid circular calls
    if (user !== null && !config.url.includes("/users/discord")) {
      const validUntil = new Date(JSON.parse(user).validUntil);
      const now = new Date();
      const difference = validUntil.valueOf() - now.valueOf();

      if (difference < 0) {
        await User.logout();
      }

      const day = 1000 * 60 * 60 * 24;
      const sixDays = day * 6;

      if (difference < sixDays) {
        await User.refresh();
      }
    }

    user = localStorage.getItem("user");
    if (user !== null && config.headers !== undefined) {
      config.headers.Authorization = `Bearer ${JSON.parse(user).accessToken}`;
    }
  }

  return config;
});

Vue.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem("user") !== null) {
      localStorage.removeItem("user");
      axios.defaults.headers.common = {};
      User.login();
      return Promise.reject(error);
    }

    const errorObject = {
      message: error.message,
      method: error.config.method,
      url: error.config.url,
      status: error.response?.status,
      statusText: error.response?.statusText,
      responseData: error.response?.data,
    };

    store.dispatch("setLastError", errorObject);
    store.dispatch("setShowErrorDialog", true);
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
